<template lang='pug'>
div
  slot(
    :prop='prop'
    :timestamp='timestamp'
    :updateProp='updateProp'
    :updateTimestamp='updateTimestamp'
  )
</template>

<script>
function updateProp(prop)
{
  this.prop = prop;

  this.updateTimestamp();

  this.$emit('update:prop', this.prop);

  return this.prop;
}

function updateTimestamp()
{
  this.timestamp = window.Date.now();
}

const prop = null;
const timestamp = window.Date.now();

export default
{
  data()
  {
    return {
      prop,
      timestamp,
    };
  },
  methods:
  {
    updateProp,
    updateTimestamp,
  },
};
</script>